module.exports = __webpack_public_path__ + "static/img/weixuanzhongchangjing.png@2x.2b3cd621.png";